import { render, staticRenderFns } from "./MainLedgerImportExcel.vue?vue&type=template&id=3ff0a23a"
import script from "./MainLedgerImportExcel.vue?vue&type=script&lang=js"
export * from "./MainLedgerImportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports